import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { DebounceInput } from 'react-debounce-input';
import { Icon } from '../../../../../../../../../../components/Icon';
import { LoadMoreButton } from '../../../../../../../../../../components/LoadMoreButton';

interface PropTypes {
  candidateEmails: string[];
  entriesCount: number;
  hasMore: boolean;
  isLoadingMore: boolean;
  search: string;
  onSearchChange: (value: string) => void;
  onLoadMore: () => Promise<void>;
}

export function CandidateEmailsList(props: PropTypes) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (props.candidateEmails.length === 0 && !props.search) {
    return null;
  }

  return (
    <div className='mb-3'>
      <Button
        color='link'
        className='p-0 text-decoration-none'
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Icon
          name={isExpanded ? 'bi-chevron-down' : 'bi-chevron-right'}
          className='me-1'
        />
        {isExpanded ? 'Hide' : 'Show'} affected candidates
      </Button>
      {isExpanded && (
        <>
          <div className='position-relative mt-2'>
            <DebounceInput
              type='text'
              placeholder='Search emails...'
              debounceTimeout={300}
              className='form-control form-control-sm pe-4 ps-3'
              value={props.search}
              onChange={(e) => props.onSearchChange(e.target.value)}
            />
            {props.search && (
              <button
                type='button'
                className='position-absolute top-50 translate-middle-y border-0 bg-transparent p-0'
                style={{ right: '8px' }}
                onClick={() => props.onSearchChange('')}
              >
                <i className='bi bi-x fs-5 text-muted' />
              </button>
            )}
          </div>
          <div
            className='overflow-auto border rounded-1 p-2 mt-2'
            style={{ maxHeight: '250px' }}
          >
            {props.candidateEmails.map((email, index) => (
              <div key={index} className='fs-4 p-2 border-bottom'>
                {email}
              </div>
            ))}
            {props.candidateEmails.length === 0 && props.search && (
              <div className='p-2 text-muted fst-italic small'>
                No candidates found matching &quot;{props.search}&quot;
              </div>
            )}
          </div>
          {props.candidateEmails.length > 0 && (
            <div className='mt-2 text-center'>
              <span className='text-muted small'>
                Showing {props.candidateEmails.length} of {props.entriesCount}{' '}
                records
              </span>
              {props.hasMore && (
                <LoadMoreButton
                  isLoading={props.isLoadingMore}
                  loadElements={props.onLoadMore}
                />
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
